"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralChart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const date_fns_1 = require("date-fns");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const styled_1 = require("@framework/styled");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const utils_1 = require("../../../../../utils");
const search_1 = require("./search");
const REFERRAL_REPORT_CHART_URL = "/referral/report/chart";
const ReferralChart = () => {
    const { isLoading, allRows } = (0, react_hooks_1.useFetchQuery)(REFERRAL_REPORT_CHART_URL, void 0, void 0, {
        startTimestamp: (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(new Date(), 1)).toISOString(),
        endTimestamp: (0, date_fns_1.endOfMonth)((0, date_fns_1.addMonths)(new Date(), 1)).toISOString(),
    });
    const chartRef = (0, react_1.useRef)(null);
    const clearChart = (0, react_1.useCallback)(() => {
        while (chartRef.current?.lastChild) {
            chartRef.current.removeChild(chartRef.current.lastChild);
        }
    }, [chartRef.current]);
    (0, react_1.useEffect)(() => {
        if (!chartRef.current) {
            return;
        }
        if (!allRows.length) {
            clearChart();
        }
        else {
            (0, utils_1.referralChartCreator)(chartRef, allRows, clearChart);
        }
    }, [chartRef.current, allRows]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "referral", "referral.chart"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.referral.chart.title" }), (0, jsx_runtime_1.jsx)(search_1.ReferralReportSearchForm, {}), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledEmptyWrapper, { count: allRows.length, isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(material_1.Box, { mt: 4, width: "100%", ref: chartRef, overflow: "visible" }) }) })] }));
};
exports.ReferralChart = ReferralChart;
//# sourceMappingURL=index.js.map